"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SATELLITE_MOVE_WINDOW_DAYS = exports.SAA_APPROACHING_RATIO = exports.SAA_ACUTE_MASS_LIMIT_KG = exports.SAA_ACUTE_VOLUME_LIMIT_GAL = exports.SAA_NON_ACUTE_VOLUME_LIMIT_GAL = void 0;
/**
 * Federal satellite-accumulation-area limits (40 CFR 262.15). The two acute
 * limits and the non-acute limit apply SIMULTANEOUSLY per area. There is no
 * QUARTS UnitType; the 1-quart acute limit is expressed in gallons.
 */
exports.SAA_NON_ACUTE_VOLUME_LIMIT_GAL = 55;
exports.SAA_ACUTE_VOLUME_LIMIT_GAL = 0.25;
exports.SAA_ACUTE_MASS_LIMIT_KG = 1;
/** A component is APPROACHING at >= this fraction of its threshold. */
exports.SAA_APPROACHING_RATIO = 0.8;
/**
 * Days allowed to move excess waste to central once a satellite area trips a
 * threshold. Pending SME confirmation; single point of change.
 */
exports.SATELLITE_MOVE_WINDOW_DAYS = 3;
//# sourceMappingURL=saaThresholds.js.map